import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { ApplicationState } from '@/state/root.models'

import { RestApiService } from '@/services'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { BONUS_PROGRAMS } from './api.routes'

import ActionTypes from '../constants'
import {
  GetOneBonusPayload,
  BonusEngineState,
  BonusProviderCategory,
} from '../models'

const restApiService: RestApiService = Container.get(RestApiService)

export const getProviderCategoriesThunk = createAsyncThunk(
  ActionTypes.GET_PROVIDER_CATEGORIES,
  async (payload: GetOneBonusPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'GET',
        endpoint: BONUS_PROGRAMS.FIND_PROVIDERS_CATEGORY,
        queries: '',
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: any = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const getProviderCategoriesExtraReducer = (
  builder: ActionReducerMapBuilder<BonusEngineState>,
) => {
  builder.addCase(getProviderCategoriesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(
    getProviderCategoriesThunk.fulfilled,
    (state, { payload }) => {
      state.isLoading = false
      state.providersCategories = payload.filter(
        (doc: BonusProviderCategory) => doc.id === 4,
      )
    },
  )
}

export default getProviderCategoriesExtraReducer
